<p>
  auth-listen works!
</p>
